module.exports = __webpack_public_path__ + "img/e1a8bcd.jpg";